export default "__VITE_ASSET__lii1j$Ry__"